"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exercises = void 0;
const ExerciseCheckbox_1 = __importDefault(require("@app/routes/IPOCPage/components/ExerciseCheckbox"));
const common_1 = require("@components/common");
const react_1 = __importStar(require("react"));
const Link_1 = require("@components/buttons/Link");
const defaultItemNumber = 15;
const Exercises = ({ exercises, chooseExercise, removeExercise, selectedTags, groupSlug, t, }) => {
    const [showAll, setShowAll] = (0, react_1.useState)(false);
    const showMoreButton = (exercises === null || exercises === void 0 ? void 0 : exercises.length) > defaultItemNumber;
    const toggleShowAll = () => setShowAll((prevState) => !prevState);
    const showAllText = showAll ? t.showLess : t.showMore;
    const visibleExercises = showAll ? exercises : exercises.slice(0, defaultItemNumber);
    return (react_1.default.createElement(react_1.default.Fragment, null, visibleExercises === null || visibleExercises === void 0 ? void 0 :
        visibleExercises.map((exercise) => (react_1.default.createElement(ExerciseCheckbox_1.default, { groupSlug: groupSlug, onChoose: chooseExercise, onRemove: removeExercise, key: exercise.slug, exercise: exercise, selected: !!selectedTags.find((e) => e.id === exercise.slug) }))),
        showMoreButton && exercises.length !== 0 && (react_1.default.createElement(common_1.Box, { mt: "20px", width: "100%" },
            react_1.default.createElement(Link_1.Link, { onClick: toggleShowAll }, showAllText)))));
};
exports.Exercises = Exercises;
